import { useAlert, useNotification } from '@btime/react-messager'
import { useMutation, gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveScreen($id: Int) {
    removeScreen(id: $id)
  }
`

export const useRemoveProcess = () => {
  const { t } = useTranslation('processes')
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Screens'],
    client: generalClient
  })
  const modal = useAlert()

  const handleRequest = id => {
    if (!modal.confirm({ title: t('processes.remove.confirm') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: t('processes.remove.success') })
      } else {
        notify.error({ title: t('processes.remove.error') })
      }
    })
  }

  return [handleRequest, state]
}
